export default (theme) => ({
  root: {
    margin: 0,
    padding: 10,
    backgroundColor: "#e8e8e8",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: 0,
    color: "#525252",
  },
  panelTitle: {
    fontSize: "1rem",
    fontWeight: "600",
  },
  panelHeader: {
    marginTop: 15,
    fontSize: 13,
    fontWeight: 600,
    marginBottom: "1rem",
  },
  selectLabel: {
    fontSize: 13,
    fontWeight: 600,
    marginBottom: "1rem",
  },
  checkBoxStyle: {
    marginLeft: "15px",
    marginRight: 0,
  },
  errorText: {
    fontSize: 12,
    color: "#e30613",
  },
  inputLabel: {
    fontSize: 13,
  },
});
